export var HOTJAR_SUPPRESS_ATTRS = { 'data-hj-suppress': true };
